module.exports = __webpack_public_path__ + "img/Genetics.58bf63e5.svg";